import type { ReactNode } from 'react';
import type { MobileNavigationSignOut } from './types';

export default function SignOutForm({
  action,
  csrfToken,
  children,
}: MobileNavigationSignOut & { children: ReactNode }) {
  return (
    <form action={action} method="post" data-turbo="false">
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      {children}
    </form>
  );
}
